import { Component, OnInit } from '@angular/core';
import { AppMainComponent } from 'src/app/app.main.component';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { ActivatedRoute, Router } from '@angular/router';
import { Emprunt } from 'src/app/entites/emprunt';
import { ResultatSelectionItemSimple, SelectionItemSimpleComponent } from 'src/app/controles/selection-item-simple.component';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EmpruntService } from 'src/app/services/emprunt.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SelectionEmployeComponent } from 'src/app/controles/selection-employe.component';
import { EmployeEntite } from 'src/app/entites/employe';
import { SelectionEmplacementComponent } from 'src/app/controles/selection-emplacement.component';
import { Emplacement } from 'src/app/entites/emplacement';
import { ItemMin } from 'src/app/entites/item-min';
import { ItemService } from 'src/app/services/item-service';
import { ReponseBase } from 'src/app/services/reponse-base';

@Component({
  selector: 'app-ajout-emprunts',
  templateUrl: './ajout-emprunts.component.html',
  styleUrl: './ajout-emprunts.component.scss',
  providers: [ConfirmationService, MessageService, DialogService]
})
export class AjoutEmpruntsComponent extends BaseComponent implements OnInit {
  emprunt: Emprunt;
  afficherDetailItem: boolean = false;
  detailItemId: number;
  alreadyExists: boolean = false;
  warnSyncronisationEmplacement: boolean = false;
  minDateAffectation: Date;
  minDateRetour: Date

  submitting: boolean = false;

  constructor(
    sdb: DonneesBaseService,
    profilService: ProfilService,
    route: ActivatedRoute,
    router: Router,
    appMain: AppMainComponent,
    private dialogService: DialogService,
    private empruntService: EmpruntService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private itemService: ItemService
  ) {
    super(sdb, profilService, route, router, appMain);
  }

  ngOnInit(): void {
    this.verifierAccesPage('emprunt');
    this.DemarrerChargement();
    
    // Set minimum date for affectation to last week
    this.minDateAffectation = new Date();
    this.minDateAffectation.setDate(this.minDateAffectation.getDate() - 7);
    
    // Initialize emprunt object
    this.emprunt = {
      empruntId: 0,
      employeId: 0,
      itemId: 0,
      dateCreation: new Date(),
      demandeParId: 0,
      dateAffectation: new Date(),
      dateRetour: null,
      employeRetourId: null,
      emplacementRetourId: null,
      note: null,
      statut: { 
        statutId: 1, 
        nom: 'Actif'
      },
      empruntsEnfants: [] 
    };

    if (this.config?.data?.item) {
      this.emprunt.itemId = this.config.data.item.itemId;
      this.emprunt.item = this.config.data.item;
    }

    if (this.config?.data?.employe) {
      this.emprunt.employeId = this.config.data.employe.employeId;
      this.emprunt.employe = this.config.data.employe;
    }
    
    // Set initial minimum date for return
    this.updateMinDateRetour();
  }

  updateMinDateRetour(): void {
    if (this.emprunt.dateAffectation) {
      this.minDateRetour = new Date(this.emprunt.dateAffectation);
    }
  }

  onDateAffectationChange(): void {
    this.updateMinDateRetour();
    
    // If return date is before the new affectation date, clear it
    if (this.emprunt.dateRetour && this.emprunt.dateAffectation && 
        this.emprunt.dateRetour < this.emprunt.dateAffectation) {
      this.emprunt.dateRetour = null;
    }
  }

  obtenirLiaisons(): void {
    this.itemService.ObtenirLiaisonsItem(this.emprunt.itemId).subscribe((result: ReponseBase<ItemMin[]>) => {
      this.emprunt.empruntsEnfants = result.valeur.map(item => ({
        empruntEnfantId: 0,
        empruntId: this.emprunt.empruntId,
        itemId: item.itemId,
        ajoutePar: this.profilService.Profil().employe.employeId,
        dateAjout: new Date(),
        item: item,
      }));
    });
  }

  selectionnerItem(): void {
    this.dialogService.open(SelectionItemSimpleComponent, {
      header: 'Selectionner un item',
      width: '50%',
      data: {
        choixCategorieDisponible: false,
      }
    }).onClose.subscribe((result: ResultatSelectionItemSimple) => {
      if (result.item) {
        this.alreadyExists = false;
        this.empruntService.checkEmpruntExistsForItem(result.item.itemId).subscribe((exists: boolean) => {
          if (exists) {
            this.alreadyExists = true;
            this.confirmationService.confirm({
              message: 'Cet item est déjà emprunté. Voulez-vous vraiment l\'emprunter ?',
              accept: () => {
                this.emprunt.item = result.item;
                this.emprunt.itemId = result.item.itemId;
                this.obtenirLiaisons();
              },
              reject: () => {
                this.selectionnerItem();
              }
            });
          }
          
          this.emprunt.item = result.item;
          this.emprunt.itemId = result.item.itemId;
          this.obtenirLiaisons();
        });
      }
    });
  }

  selectionnerEmploye(retour: boolean = false): void {
    this.dialogService.open(SelectionEmployeComponent, {
      header: 'Selectionner un employé',
      width: '50%',
    }).onClose.subscribe((result: EmployeEntite) => {
      if (result) {
        if (!result.indAjouteAuChantier) {
          this.warnSyncronisationEmplacement = true;
        }
        if (retour) {
          this.emprunt.employeRetour = result;
          this.emprunt.employeRetourId = result.employeId;
        } else {
          this.emprunt.employe = result;
          this.emprunt.employeId = result.employeId;
        }
      }
    });
  }

  selectionnerEmplacement(retour: boolean = false): void {
    this.dialogService.open(SelectionEmplacementComponent, {
      header: 'Selectionner un emplacement',
      width: '50%',
      height: '50%',
    }).onClose.subscribe((result: Emplacement) => {
      if (result) {
        if (retour) {
          this.emprunt.emplacementRetour = result;
          this.emprunt.emplacementRetourId = result.emplacementId;
        } else {
          this.emprunt.emplacementDepart = result;
          this.emprunt.emplacementDepartId = result.emplacementId;
        }
      }
    });
  }

  annuler(): void {
    this.ref.close();
  }

  enregistrer(): void {
    this.submitting = true;
    if (!this.emprunt.item || !this.emprunt.employe || !this.emprunt.dateAffectation) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Veuillez remplir tous les champs obligatoires'
      });
      return;
    }

    this.emprunt.demandeParId = this.profilService.Profil().employe.employeId;
    // Problème de confilt entre l'entité et le dto, on doit donc l'enlever
    this.emprunt.emplacementRetour = null;

    this.empruntService.createEmprunt(this.emprunt).subscribe({
      next: (result) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail: 'Emprunt créé avec succès'
        });
        this.routerService.navigate(['/emprunt', result.empruntId]);
        this.ref.close();
        this.submitting = false;
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Erreur lors de la création de l\'emprunt: ' + (error.error || 'Erreur inconnue')
        });
        this.submitting = false;
      }
    });
  }

  afficherItem(itemId: number): void {
    this.detailItemId = itemId;
    this.afficherDetailItem = true;
  }
}
